"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _formik = require("formik");
var R = _interopRequireWildcard(require("ramda"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors = require("./store/selectors");
var _excluded = ["formik"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var withOperatorsProps = function withOperatorsProps(Component) {
  var WithOperatorsProps = function WithOperatorsProps(_ref) {
    var formik = _ref.formik,
      props = _objectWithoutProperties(_ref, _excluded);
    var values = formik.values,
      setFieldValue = formik.setFieldValue;
    var countryID = values[_fn.QUERY_PARAMS.COUNTRY],
      departuresIDs = values[_fn.QUERY_PARAMS.DEPARTURES],
      operatorsIDs = values[_fn.QUERY_PARAMS.OPERATORS],
      transports = values[_fn.QUERY_PARAMS.TRANSPORTS];
    var getOperators = (0, _react.useMemo)(function () {
      return (0, _selectors.createGetOperators)(countryID, departuresIDs);
    }, [countryID, departuresIDs]);
    var operators = (0, _reactRedux.useSelector)(getOperators);
    var transportsMap = (0, _react.useMemo)(function () {
      return R.reduce(function (acc, transportMap) {
        return R.mergeWith(R.or, acc, transportMap);
      }, {}, transports);
    }, [transports]);
    var isAllSelected = (0, _react.useMemo)(function () {
      return R.all(function (_ref2) {
        var id = _ref2.id;
        return R.includes(id, operatorsIDs);
      }, R.isEmpty(transportsMap) ? operators : R.filter(function (operator) {
        return R.any(function (transportCode) {
          return transportsMap[transportCode];
        }, operator.transports);
      }, operators));
    }, [operators, operatorsIDs, transportsMap]);
    var filteredOperators = (0, _react.useMemo)(function () {
      return R.call(R.pipe(R.groupBy(function (operator) {
        return R.isEmpty(transportsMap) ? 'true' : R.any(function (transportCode) {
          return transportsMap[transportCode];
        }, operator.transports);
      }), function (_ref3) {
        var _ref3$true = _ref3.true,
          withIncludedActiveTransport = _ref3$true === void 0 ? [] : _ref3$true,
          _ref3$false = _ref3.false,
          withoutIncludedActiveTransport = _ref3$false === void 0 ? [] : _ref3$false;
        return [withIncludedActiveTransport, withoutIncludedActiveTransport];
      }, R.map(R.sort(function (operatorA, operatorB) {
        if (operatorA.priority < operatorB.priority) {
          return -1;
        }
        if (operatorA.priority > operatorB.priority) {
          return 1;
        }
        return operatorA.name.localeCompare(operatorB.name);
      })), function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          withIncludedActiveTransport = _ref5[0],
          withoutIncludedActiveTransport = _ref5[1];
        return R.concat(R.map(R.assoc('includedActiveTransport', true), withIncludedActiveTransport), R.map(R.assoc('includedActiveTransport', false), withoutIncludedActiveTransport));
      }), operators);
    }, [operators, transportsMap]);
    var handleAllToggle = (0, _react.useCallback)(function () {
      return setFieldValue(_fn.QUERY_PARAMS.OPERATORS, isAllSelected ? [] : R.map(R.prop('id'), R.isEmpty(transportsMap) ? operators : R.filter(function (operator) {
        return R.any(function (transportCode) {
          return transportsMap[transportCode];
        }, operator.transports);
      }, operators)));
    }, [isAllSelected, operators, setFieldValue, transportsMap]);
    var handleToggle = (0, _react.useCallback)(function (id) {
      return setFieldValue(_fn.QUERY_PARAMS.OPERATORS, R.includes(id, operatorsIDs) ? R.without([id], operatorsIDs) : R.append(id, operatorsIDs));
    }, [operatorsIDs, setFieldValue]);
    return !R.isEmpty(filteredOperators) && /*#__PURE__*/_react.default.createElement(Component, _extends({
      isAllSelected: isAllSelected,
      operators: filteredOperators,
      selectedOperators: operatorsIDs,
      onAllToggle: handleAllToggle,
      onToggle: handleToggle
    }, props));
  };
  return (0, _formik.connect)(WithOperatorsProps);
};
var _default = exports.default = withOperatorsProps;